import { ReactNode } from "react";
import WindowedModalV2, { WindowedModalButtonBar } from "../windowed-modal/windowed-modal";
import { ButtonVariants } from "designer/ui/smart/button-vnext/button-vnext-lib";
import { GlideFC } from "lib/glide-fc";

export interface AcceptCancelProps {
    title: string;
    acceptButtonText: string;
    cancelButtonText: string | "Cancel";
    acceptButtonVariance?: ButtonVariants;
    children: ReactNode;
    onAccept: () => void;
    onCancel: () => void;
}
export const AcceptCancelModal: GlideFC<AcceptCancelProps> = props => {
    const { title, acceptButtonText, cancelButtonText, acceptButtonVariance, children, onAccept, onCancel } = props;
    return (
        <WindowedModalV2
            title={title}
            canClose={true}
            footer={
                <WindowedModalButtonBar
                    align="right"
                    buttons={[
                        {
                            title: cancelButtonText,
                            type: "secondary",
                            variant: "default",
                            onClick: () => onCancel(),
                        },
                        {
                            title: acceptButtonText,
                            type: "primary",
                            variant: acceptButtonVariance || "default",
                            onClick: () => onAccept(),
                        },
                    ]}
                />
            }
            onClose={() => onCancel()}>
            {children}
        </WindowedModalV2>
    );
};
